import React from "react";
import { Trash2 } from "lucide-react";
import DialogModal from "../helpers/DialogModal";

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  confirmIcon?: React.ReactNode;
  confirmButtonClass?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title, 
    message,
    confirmLabel = "Confirm Delete",
    confirmIcon = <Trash2 className="w-5 h-5" />,
    confirmButtonClass = "bg-red-600 hover:bg-red-700"
}) => {
  return (
    <DialogModal
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        size="md"
        primaryAction={{
            label: confirmLabel,
            onClick: () => {
                onConfirm();
                onClose();
            },
            icon: confirmIcon,
            className: confirmButtonClass
        }}
        secondaryAction={{
            label: 'Cancel',
            onClick: onClose
        }}
    >
      <p className="text-slate-300">{message}</p>
    </DialogModal>
  );
};

export default ConfirmModal;
